import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  TableContainer,
  Tooltip,
  Chip,
} from "@mui/material";

function EvidenceHistory({ history, onDownload, onView }) {
  return (
    <Paper
      sx={{
        mt: 4,
        p: 3,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Previous Uploads
      </Typography>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>File</TableCell>

              <TableCell>Uploaded</TableCell>

              <TableCell>Relevance</TableCell>

              <TableCell>Quality</TableCell>

              <TableCell>Decision</TableCell>
              <TableCell colSpan={2} sx={{ textAlign: "center" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {history.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.original_file_name}</TableCell>

                <TableCell>{row.uploaded_at}</TableCell>

                <TableCell>
                  {row.relevance_score ? row.relevance_score + "%" : "N/A"}
                </TableCell>

                <TableCell>
                  {row.quality_score ? row.quality_score + "%" : "N/A"}
                </TableCell>

                <TableCell>
                  <Tooltip
                    title={
                      row.reasoning === null
                        ? "No reasoning provided"
                        : row.reasoning || "No reasoning provided"
                    }
                    arrow
                  >
                    <Chip
                      label={row.decision ? row.decision : "N/A"}
                      size="small"
                    />
                  </Tooltip>
                </TableCell>

                {row.relevance_score !== null && (
                  <>
                    <TableCell>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => onView(row.id)}
                        sx={{
                          bgcolor: "#059669",

                          "&:hover": {
                            bgcolor: "#047857",
                          },
                          color: "#fff",
                          mr: 1,
                        }}
                      >
                        View
                      </Button>
                   
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => onDownload(row.id)}
                        sx={{
                          bgcolor: "#b7ab02",

                          "&:hover": {
                            bgcolor: "#dbf259",
                          },
                          color: "#fff",
                          ml: 1,
                        }}
                      >
                        Download
                      </Button>
                    </TableCell>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default EvidenceHistory;
